export const listData = {
    // 没有清单的类型
    notListType: [6,7,8,9,10,13,20]
}
export const listMethods = {
    // 没有清单就不展示body
    showBody (item, type = 'tender') {
        if (item.dataSources === 2 && item.goodsList && item.goodsList.length > 0) return true
        if (type == 'bid') {
            if (this.notListType.includes(item.type) || !item.goodsList || item.goodsList.length == 0) {
                return false
            }
        } else {
            // 不知道的判断条件 item.dataSources === 2 || item.businessType == 4
            if (this.notListType.includes(item.type) || item.businessType == 4 || !item.goodsList || item.goodsList.length == 0) {
                return false
            }
        }

        return true
    },
    createTimeInfo (item) {
        let self = this
        let label = '', time = '', timeHouse = function (time) {
            if (!Number(time)) return defaultStr
            return self.$options.filters['formaHoures'](Number(time))
        }
        if (item.businessType == 3) {
            label = '发布时间'
            time = item.created ? timeHouse(item.created) : this.getDefaultCopy(item)
        } else {
            label = '发布时间'
            time = item.releaseTime ? timeHouse(item.releaseTime) : this.getDefaultCopy(item)
        }

        return {
            label,
            time
        }
    },
    // 获取默认文案
    getDefaultCopy (item) {
        return item.businessType == 2 ? '详见采购文件说明' : '详见招标文件说明'
    },
    // 第二个时间是动态展示的(三种情况，竞价2，招标1)
    timeInfo (item) {
        let self = this
        let label = '', time = '', labelOne = '', timeOne = ''
        let defaultStr = item.businessType == 2 ? '详见采购文件说明' : '详见招标文件说明'
        let timeDay = function (time) {
            return self.$options.filters['formatDay'](Number(time))
        }, timeHouse = function (time) {
            if (!Number(time)) return defaultStr
            return self.$options.filters['formaHoures'](Number(time))
        }
        const { applyStartTime, applyEndTime, bidStartTime, bidEndTime, openBidTime, calibrationTime } = item
        if (item.businessType == 2) {
            if (item.state == 2 || item.state == 5) {
                // 如果需要显示最低或者最高报价就把时间字段整合，如果不限制最低或者最高报价就分开
                if (this.notListType.includes(item.type) && item.isDisplay == 1) {
                    labelOne = '报价时间'
                    timeOne = (Number(applyStartTime) && Number(applyEndTime)) ? `${timeDay(applyStartTime)} - ${timeDay(applyEndTime)}` : defaultStr

                    label = item.rankType === 1 ? '最低报价' : item.rankType === 3 ? '最高报价' : ''
                    time = item.minMoney + '元'
                } else {
                    labelOne = '报价开始时间'
                    timeOne = timeHouse(applyStartTime)

                    label = '报价结束时间'
                    time = timeHouse(applyEndTime)
                }
            } else if (item.state == 3) {
                labelOne = '报价时间'
                timeOne = (Number(applyStartTime) && Number(applyEndTime)) ? `${timeDay(applyStartTime)} - ${timeDay(applyEndTime)}` : defaultStr

                label = '定标时间'
                time = timeHouse(calibrationTime)
            }
        } else {
            switch(item.state) {
                case 8:
                    labelOne = '报名开始时间'
                    timeOne = timeHouse(applyStartTime)

                    label = '报名结束时间'
                    time = timeHouse(applyEndTime)
                break
                case 9:
                    labelOne = '报名时间'
                    timeOne = (Number(applyStartTime) && Number(applyEndTime)) ? `${timeDay(applyStartTime)} - ${timeDay(applyEndTime)}` : defaultStr

                    label = '投标时间'
                    time = (Number(bidStartTime) && Number(bidEndTime)) ? `${timeDay(bidStartTime)} - ${timeDay(bidEndTime)}` : defaultStr
                break
                case 1:
                case 2:
                case 3:
                case 6:
                    labelOne = '投标时间'
                    timeOne = (Number(bidStartTime) && Number(bidEndTime)) ? `${timeDay(bidStartTime)} - ${timeDay(bidEndTime)}` : defaultStr

                    label = '开标时间'
                    time = timeHouse(openBidTime)
                break
                case 4:
                    labelOne = '投标时间'
                    timeOne = (Number(bidStartTime) && Number(bidEndTime)) ? `${timeDay(bidStartTime)} - ${timeDay(bidEndTime)}` : defaultStr

                    label = '定标时间'
                    time = timeHouse(calibrationTime)
                break
            }
        }

        return {
            label,
            time,
            labelOne,
            timeOne
        }
    },
    // 判断当前行是否显示
    showCurrentRow (item, length) {
        if (!item.goodsList || !item.goodsList.length) {
            return true
        } else if (item.goodsList && item.goodsList.length < length) {
            return true
        }
    }
}